import React from "react";
import {
  AbilityPhase,
  AbilityUsage,
  getPlayerAbilities,
  canUseAbility,
} from "./abilities";
import { RolePlayer } from "./RoleDistributorReducer";
import { useTranslation } from "react-i18next";

interface Props {
  onClick: () => void;
  abilityPhase: AbilityPhase;
  currentPlayer: RolePlayer;
  abilityUsages: AbilityUsage[];
}

const AbilityButton: React.FC<Props> = ({
  onClick,
  abilityPhase,
  currentPlayer,
  abilityUsages,
}) => {
  const { t } = useTranslation();

  // 현재 플레이어가 보유한 능력 목록
  const playerAbilities = getPlayerAbilities(currentPlayer.abilities || []);

  // 능력이 없으면 버튼을 표시하지 않음
  if (playerAbilities.length === 0) {
    return null;
  }

  // 사용 가능한 능력 개수 계산
  const availableAbilities = playerAbilities.filter(
    (ability) =>
      abilityPhase.isActive &&
      canUseAbility(ability.id, currentPlayer.id, abilityPhase, abilityUsages)
  ).length;

  // 버튼 활성화 상태
  const isActive = abilityPhase.isActive && availableAbilities > 0;

  return (
    <button
      className={`ability-button ${isActive ? "active" : "inactive"}`}
      onClick={onClick}
    >
      <div className="ability-button-content">
        <span className="ability-button-icon">{isActive ? "⚡" : "🔒"}</span>
        <span className="ability-button-text">
          {t("RoleDistributor.specialActions", "액션")}
        </span>
        {availableAbilities > 0 && (
          <span className="ability-button-badge">{availableAbilities}</span>
        )}
      </div>
    </button>
  );
};

export default AbilityButton;
